"use client";

export { default as MetadataBadge } from "./MetadataBadge";
